import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Loader } from 'lucide-react';
import api from '../lib/api';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';

export default function Reorder() {
  const { orderId } = useParams();
  const nav = useNavigate();
  const { items, add, clear } = useCart();
  const { toast } = useToast();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        const { data } = await api.get(`/orders/${orderId}/items`);
        if (!data.items?.length) throw new Error('empty');
        // Also fetch current menu so we can validate availability + refresh prices
        const menuRes = await api.get('/menu');
        const menuMap = new Map(menuRes.data.map((m) => [m.id, m]));
        clear();
        let unavailable = 0;
        data.items.forEach((it) => {
          const menuItem = menuMap.get(it.menuItemId);
          if (menuItem && menuItem.available) {
            for (let i = 0; i < it.qty; i++) {
              add({ id: menuItem.id, name: menuItem.name, price: menuItem.price, image: menuItem.image });
            }
          } else {
            unavailable += 1;
          }
        });
        if (unavailable > 0) toast({ title: 'Some items unavailable', description: `${unavailable} item(s) from your last order aren\u2019t available anymore.` });
        else toast({ title: 'Cart loaded!', description: 'Review your order and continue to checkout.' });
        nav('/checkout');
      } catch (err) {
        toast({ title: 'Could not reorder', description: err?.response?.data?.detail || 'Order not found.' });
        nav('/menu');
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  return (
    <div className="min-h-screen flex items-center justify-center text-gray-500 gap-2">
      <Loader size={16} className="animate-spin" /> Loading your last order into cart...
    </div>
  );
}
